import React, { memo, useCallback } from 'react';
import { Flex } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const pillStyle: React.CSSProperties = {
  height: '27px',
  padding: '0 12px',
  backgroundColor: '#000000',
  fontSize: '10px',
  fontWeight: '600',
  color: '#fff',
  borderRadius: '40px',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  width: 'fit-content',
};

interface PillProps {
  label: string;
  onClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
  onRemove?: () => void;
  title?: string;
}

function Pill({ label, onClick, onRemove, title }: PillProps) {
  const onKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (!onClick) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick(e);
      }
    },
    [onClick]
  );

  return (
    <Flex
      gap={8}
      align='center'
      style={pillStyle}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <span>{label}</span>
      {typeof onRemove === 'function' && (
        <CloseOutlined
          style={{ color: '#fff', fontSize: 12, cursor: 'pointer' }}
          tabIndex={0}
          role='button'
          aria-label={`Remove ${title}`}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onRemove();
            }
          }}
          title={title}
        />
      )}
    </Flex>
  );
}

export default memo(Pill);
